module.exports = __webpack_public_path__ + "img/complete.6a1087c0.png";